const legal = [
  {
    section: 'Purchaser Information',
    q: {
      unit: {
        label: 'Unit # *',
        required: true,
        name: 'answers[25414][answers]',
        id: 'answers_25414',
        type: 'number',
      },
      strata: {
        label: 'Strata Lot *',
        required: true,
        name: 'answers[25415][answers]',
        id: 'answers_25415',
        type: 'number',
      },
      purchaserFirstName: {
        label: 'Purchaser First Name *',
        required: true,
        name: 'contact[first_name]',
        id: 'contact_first_name',
        type: 'text',
      },
      purchaserLastName: {
        label: 'Purchaser Last Name *',
        required: true,
        name: 'contact[last_name]',
        id: 'contact_last_name',
        type: 'text',
      },
      purchaserEmail: {
        label: 'Purchaser Email *',
        required: true,
        name: 'contact[email]',
        id: 'contact_email',
        type: 'email',
      },
      purchaserPhone: {
        label: 'Purchaser Phone *',
        required: true,
        name: 'contact[phone]',
        id: 'contact_phone',
        type: 'tel',
      },
    },
  },
  {
    section: 'Lawyer / Notary Form',
    q: {
      lawFirm: {
        label: 'Law Firm / Notary *',
        required: true,
        name: 'answers[25420][answers]',
        id: 'answers_25420',
        type: 'text',
      },
      legalContactFirstName: {
        label: 'Legal Contact First Name *',
        required: true,
        name: 'contact[l_first_name]',
        id: 'contact_l_first_name',
        type: 'text',
      },
      legalContactLastName: {
        label: 'Legal Contact Last Name *',
        required: true,
        name: 'contact[l_last_name]',
        id: 'contact_l_last_name',
        type: 'text',
      },
      legalEmail: {
        label: 'Legal Contact Email *',
        required: true,
        name: 'contact[l_email]',
        id: 'contact_l_email',
        type: 'email',
      },
      legalPhone: {
        label: 'Legal Contact Phone *',
        required: true,
        name: 'contact[l_phone]',
        id: 'contact_l_phone',
        type: 'tel',
      },
      mortgageInfo: {
        label: 'Financial Institution / Bank Name',
        required: false,
        name: 'answers[25425][answers]',
        id: 'answers_25425',
        type: 'text',
      },
    },
  },
];

export default legal;
